import * as React from 'react';

interface GoogleMapEmbedProps {
    height?: string | number;
    width?: string | number;
    query?: string;
}

/**
 * Google map using iframe (cheaper than dynamic API).
 * Prioritizes lat/lng over address if both passed
 */
export default class GoogleMapEmbed extends React.Component<GoogleMapEmbedProps, {}> {
    static defaultProps: Partial<GoogleMapEmbedProps> = {
        height: 450,
        width: 600,
    };

    render() {
        const { width, height, query } = this.props;

        if (query === undefined) {
            return null;
        }

        return <iframe width={width} height={height} style={{ border: 0 }} src={query} />;
    }
}
